(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ecCom"), require("React"), require("mobx"), require("mobxReact"), require("ReactRouter"), require("ReactDOM"), require("History"), require("weaDocDetail"));
	else if(typeof define === 'function' && define.amd)
		define(["ecCom", "React", "mobx", "mobxReact", "ReactRouter", "ReactDOM", "History", "weaDocDetail"], factory);
	else if(typeof exports === 'object')
		exports["weaDocDetail"] = factory(require("ecCom"), require("React"), require("mobx"), require("mobxReact"), require("ReactRouter"), require("ReactDOM"), require("History"), require("weaDocDetail"));
	else
		root["weaDocDetail"] = factory(root["ecCom"], root["React"], root["mobx"], root["mobxReact"], root["ReactRouter"], root["ReactDOM"], root["History"], root["weaDocDetail"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_72__, __WEBPACK_EXTERNAL_MODULE_259__, __WEBPACK_EXTERNAL_MODULE_260__, __WEBPACK_EXTERNAL_MODULE_262__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition